import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./CreditConfirmation.module.scss";
import validator from "../../../utils/validator";
import analyticsService from "../../../services/analytics/analyticsService";
import useSendEmail from "../../../hooks/useSendEmail";

function CreditConfirmation(props: any) {
  const location = useLocation();
  const navigate = useNavigate();
  const { version } = props;
  const [sendEmail] = useSendEmail();
  const [email, setEmail] = useState({
    value: "",
    error: "",
    touched: false,
  });
  
  library.add(faCheckCircle);
  let dumble = new analyticsService();

  const {
    payAmt, cardType, orderId
  } = location.state as any;

  const handleInput = ((type: string, input: any, field: object) => {
    const newField: any = { ...field };
    newField[type] = input;
    return newField;
  });

  useEffect(() => {
    dumble.initDumblePage("Payment Portal:Credit Card:Payment Confirmation");
    dumble.setDumbleCreditCartInfo(cardType, "Credit Card", payAmt, "some tax", orderId);
  }, [])

  useEffect(() => {
    setEmail(handleInput("error", validator(email.value, ["emailFormat"]), email));
  }, [email.value]);

  const sendEmailSuccess = async () => {
    const { data, error } = await sendEmail(orderId, {email: email.value});
    if (error) console.log(error);
    else if (data !== null){
      let type: string;
      if (version === "creditcard") type = "email";
      else type = "refund";
      dumble.initDumblePage("Payment Portal:Credit Card:Payment Email Confirmation");
      navigate("/success", { state: { toasterType: type } });
    }

  };

  const noEmailNavSuccess = (e:any) => {
    e.preventDefault();
    navigate("/");
  };

  const displayError = (input: any) => {
    if (input.error && input.value) {
      return (
        <div className={styles.errorMessage}>
          {input.error}
        </div>
      );
    }
    return <div><br/></div>;
  };

  const disableButton = () => {
    if (email.error !== "") return true;
    return false;
  };

  return (
    <div className={styles.CreditConfirmation} data-testid="CreditConfirmation">
      <div>
        <div className={styles.transaction}>
          <FontAwesomeIcon icon={faCheckCircle} className={styles.check} />
          Transaction successful
        </div>
        <div className={`${styles.amount} ${version === "remit" ? styles.remitamount : ""}`}>
          <h3>
            Amount:
          </h3>
          <h3>
            {`$${payAmt}`}
          </h3>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={styles.email}>
          <label htmlFor="sendEmail">
            Email for Reciept
            <input
              type="text"
              value={email.value}
              onChange={(e) => setEmail(handleInput("value", e.target.value, email))}
              id="email"
              aria-label="email"
            />
            {displayError(email)}
          </label>
          <button
            type="submit"
            onClick={sendEmailSuccess}
            className={styles.button}
            id="sendbutton"
            disabled={disableButton()}
          >
            SEND RECEIPT
          </button>
        </div>
        <hr className={styles.linebreak} />
        <button
          type="button"
          id="noreceiptbutton"
          onClick={noEmailNavSuccess}
          className={`${styles.button} ${styles.noreciept}`}
        >
          NO RECEIPT
        </button>
      </div>
    </div>
  );
}

export default CreditConfirmation;
